import { BaseAPI } from "./base-api";
/**
 * Helper class que tiene como objetivo
 * agrupar las invocaciones a la api de planos.
 */
class PlanoAPI extends BaseAPI {
  resource = "/planos/";

}

export default new PlanoAPI();
